<template>
  <header
    class="main-nav main-nav-covantage-override"
    :class="[
      { sticking: sticking },
      (siteConfig && siteConfig.navBottomBorderColor === 'green') ? 'border-neon-green' : 'border-orange',
      { 'nav-open': !hideNav },
      { 'has-utility-nav': (utilityLinks.length || siteConfig.utilityNavContactPhone) }
    ]"
  >
    <div
      v-if="!smAndDown && (utilityLinks.length || siteConfig.utilityNavContactPhone)"
      class="utility-nav font-small light-gray dark-gray--text"
    >
      <div class="content-center">
        <div class="content-constraint">
          <a tabindex="0" class="skip-link sr-only" href="#full-container-content">Skip to content</a>
          <div
            class="d-flex align-center justify-end"
            style="height: 40px;"
          >
            <nav aria-label="Utility menu">
              <ctf-link
                v-for="(link, i) in utilityLinks"
                :key="'utility-nav-link-' + i"
                :btn-id="link.sys.id"
                class="px-3 utility-menu-item"
                utility-nav-link
              />
            </nav>
            <span
              v-if="siteConfig.utilityNavContactPhone"
              class="font-weight-extra"
            >
              Call us at
              <a
                :href="'tel:' + siteConfig.utilityNavContactPhone"
                class="dark-gray--text"
              >
                {{ siteConfig.utilityNavContactPhone }}
              </a>
              <a
                v-if="siteConfig.utilityNavContactPhoneTty"
                :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
                class="ml-3 dark-gray--text"
              >
                TTY: {{ siteConfig.utilityNavContactPhoneTty }}
              </a>
            </span>
            <utility-nav-btn
              v-if="siteConfig.utilityNavButton"
              :btn-id="siteConfig.utilityNavButton.sys.id"
            ></utility-nav-btn>
            <utility-nav-btn
              v-if="siteConfig.utilityNavButton2"
              :btn-id="siteConfig.utilityNavButton2.sys.id"
            ></utility-nav-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="app-header secondary--text content-center">
      <div class="content-constraint d-flex flex-column">
        <div
          class="d-flex"
          style="height: 82px;"
        >
          <div
            v-if="siteConfig && siteConfig.navigationLogo"
            class="d-flex justify-center align-center mr-auto"
          >
            <router-link
              :to="getHomeURL()"
            >
            <div class="image-wrapper">
                <img
                  :src="siteConfig.navigationLogo.url"
                  :alt="siteName"
                  class="logo"
                  @click.prevent="navigateHomeOrToTop"
                  :style="logoMaxHeight"
              />
              </div>
            </router-link>
          </div>
          <div
            v-if="links"
            class="d-flex align-center"
          >
            <v-list
              v-if="!smAndDown"
              id="nav-links"
              class="d-flex px-0 py-0 no-background"
              role="navigation"
              nav
              aria-label="Site menu"
            >
              <ctf-link
                v-for="(link, i) in links"
                :key="'nav-link-' + i"
                :btn-id="link.sys.id"
                :activeMenu="activeMenu"
                class="ctf-nav-link"
                nav-link
                @open-dropdown="updateActive"
              />
            </v-list>
            <div
              v-else
              class="d-flex align-center"
            >
              <v-btn
                aria-controls="nav-links"
                class="menu-button"
                color="primary"
                :aria-expanded="String(!hideNav)"
                style="font-weight: bold !important"
                text
                @click="hideNav = !hideNav"
                ref="menuButton"
              >
                {{ hideNav ? 'menu' : 'close' }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <v-expand-transition v-if="smAndDown && !hideNav">
        <div style="width: 100%;" id="nav-links">
          <!-- v-expand-transition causes slide animation when element within is rendered -->
          <div
            v-if="links"
            class="d-flex flex-column justify-start content-constraint"
            style="width: 100%;"
          >
            <ctf-link
              v-for="(link, i) in links"
              :key="'nav-link-' + i"
              :btn-id="link.sys.id"
              nav-link
              group
            />
          </div>
          <div
            v-if="(utilityLinks.length || siteConfig.utilityNavContactPhone)"
            class="utility-nav light-gray dark-gray--text"
          >
            <div class="content-constraint">
              <div
                class="d-flex flex-column align-start justify-center mx-2"
                style="width: 100%;"
              >
                <div
                  v-if="utilityLinks.length"
                  class="d-flex align-center justify-space-between mt-4"
                  style="width: 100%;"
                >
                  <ctf-link
                    v-for="(link, i) in utilityLinks"
                    :key="'utility-nav-link-' + i"
                    :btn-id="link.sys.id"
                    class="pa-1"
                    utility-nav-link
                  />
                </div>
                <div
                  v-if="siteConfig.utilityNavContactPhone || siteConfig.utilityNavContactPhoneTty"
                  class="d-flex justify-space-between mt-4 mb-3 pa-1"
                  style="width: 100%;"
                >
                  <span class="font-weight-extra">
                    Call us at
                    <a
                      v-if="siteConfig.utilityNavContactPhone"
                      :href="'tel:' + siteConfig.utilityNavContactPhone"
                      class="dark-gray--text"
                    >
                      {{ siteConfig.utilityNavContactPhone }}
                    </a>
                    <br>
                    <a
                      v-if="siteConfig.utilityNavContactPhoneTty && siteConfig.utilityNavContactPhone"
                      :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
                      class="dark-gray--text"
                    >
                      TTY: {{ siteConfig.utilityNavContactPhoneTty }}
                    </a>
                  </span>
                  <utility-nav-btn
                    v-if="siteConfig.utilityNavButton"
                    :btn-id="siteConfig.utilityNavButton.sys.id"
                  ></utility-nav-btn>
                  <utility-nav-btn
                    v-if="siteConfig.utilityNavButton2"
                    :btn-id="siteConfig.utilityNavButton2.sys.id"
                  ></utility-nav-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import CtfLink from '../snippets/ctf-link'
import UtilityNavBtn from '../snippets/utility-nav-btn'

export default {
  name: 'TheMainNav',
  components: {
    CtfLink,
    UtilityNavBtn
  },
  data () {
    return {
      sticking: false,
      hideNav: true,
      activeMenu: null,
      siteName: ''
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig }),
    links () {
      if (!this.siteConfig) {
        return
      }
      return this.siteConfig.mainNavigation
    },
    logoMaxHeight () {
      return this.sticking ? 'max-height: 38px' : 'max-height: 46px'
    },
    utilityLinks () {
      if (!this.siteConfig) {
        return
      }
      return this.siteConfig.utilityNavLinks || []
    },
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  watch: {
    $route (to, from) {
      if (this.smAndDown) {
        this.hideNav = true
      }
    }
  },
  mounted () {
    this.headerSize()
    window.addEventListener('scroll', this.handleScroll)
    this.siteName = window.location.host.includes('vermont') ? 'Vermont Blue Advantage Homepage' : 'NextBlue of North Dakota Homepage'
  },
  methods: {
    handleScroll () {
      this.headerSize()
    },
    updateActive (model) {
      this.activeMenu = model
    },
    headerSize () {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      const scrollHeight =
        document.documentElement.scrollHeight ||
        document.body.scrollHeight ||
        0
      const clientHeight =
        document.documentElement.clientHeight ||
        document.body.clientHeight ||
        0
      /* On stick, the tab nav disappears and the main nav shrinks, which caused scrollTop to change to 0 and back
       * on certain window sizes, and therefore alternate quickly between sticking and not sticking.
       * The following line checks the height difference against a number that is slightly higher than
       * the combination of the tab nav height and the height of the main nav that is lost when it's sticking,
       * and the 'sticking' value is not set when within that range. */
      const ignoreForRange = scrollHeight - clientHeight <= 125

      if (scrollTop > 35 && !this.sticking && !ignoreForRange) {
        this.sticking = true
      } else if (scrollTop < 35 && this.sticking) {
        this.sticking = false
      }
    },
    navigateHomeOrToTop () {
      if (this.$router.currentRoute.fullPath === this.getHomeURL()) {
        this.$scrollTo(document.getElementById('page-top'))
        return
      }
      this.$router.push(this.getHomeURL())
    },
    getHomeURL () {
      let homeURL = this.siteConfig.siteBaseUrl
      const regexp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\b([-a-zA-Z0-9@:%_]*)/g
      homeURL = homeURL.replace(regexp, '/')
      homeURL = homeURL.replace('//', '/')
      return homeURL
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";

.main-nav {
  position: sticky;
  top: 0;
  z-index: 200;
  min-height: 82px;
  background-color: $white;
  transition: box-shadow 0.5s, max-height 0.5s, min-height 0.5s;

  .utility-menu-item{
    display: inline-block;
  }

  &.sticking:not(.nav-open) {
    &:not(.has-utility-nav) {
      max-height: 65px !important;
      min-height: 65px !important;
    }
    box-shadow: 0 0.5em 0.5em 0 rgba(0, 0, 0, 0.4);
    .app-header {
      max-height: 65px !important;
      min-height: 65px !important;
      .content-constraint {
        max-height: 65px !important;
        min-height: 65px !important;
      }
    }
    ::v-deep .v-toolbar__content {
      height: 65px !important;
    }
    .content-constraint {
      justify-content: space-between;
    }
  }
}

.skip-link {
  position: absolute;
  top: 10px;
}

// .menu-button:active{
//   outline: black 2px solid;
//   outline-offset: 2px;
// }

.skip-link:focus {
  clip: revert;
  -webkit-clip-path: revert;
  clip-path: revert;
  height: revert;
  width: revert;
  margin: revert;
  overflow: revert;
  padding: revert;
}

.logo {
  transition: max-height 0.5s, height 0.5s;
}

.image-wrapper {
  img {
    max-width: 100%;
    display: block;
    max-width: 189px;
    min-width: 180px;
    object-fit: contain;
  }
}

.border-neon-green {
  border-bottom: 5px solid $neon-green;
}
.border-orange {
  border-bottom: 5px solid #d98b3d;
}

::v-deep .v-list-item--link {
  border: none;
  background: none;
  font-weight: $font-weight-extra;
  .v-list-item__title {
    color: $primary !important;
    transition: color 0.5s !important;
  }
  &:before,
  &:focus {
    background: none;
    border: none;
  }
  &:hover {
    .v-list-item__title {
      color: $secondary !important;
    }
  }
}
::v-deep .ctf-nav-link:last-child {
  * {
    margin-right: 0 !important;
  }
}
::v-deep .v-list-group__header {
  padding: 0px !important;
}
::v-deep .v-list-item__title {
  flex: unset;
}
::v-deep .v-list-item__icon {
  min-width: unset !important;
  margin-left: unset !important;
}
.main-nav-covantage-override {
  ::v-deep .v-list-item__icon {
    min-width: unset !important;
    margin-left: unset !important;
  }
  ::v-deep .v-list-item__title {
    flex: unset !important;
  }
  ::v-deep .v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
    transform: rotate(0deg);
  }
  ::v-deep .v-list-group__header > .v-list-group__header__append-icon .v-icon  {
    transform: rotate(-90deg);
    color: #007BBD !important;
  }
}
.v-list-group {
  padding: 0px !important;
  @media only screen and (min-width:601px) {
    margin-left: 8px;
  }
}

::v-deep .v-list-item--active {
  .v-list-item__title {
    color: $secondary !important;
  }
}

::v-deep .v-toolbar__content {
  height: 82px !important;
  width: 100%;
  justify-content: center;
  padding: 0;
}

.utility-nav {
  position: sticky;
  top: 0;
  z-index: 240;
  width: 100%;
}

.app-header {
  position: sticky;
  top: 0;
  z-index: 200;
  min-height: 82px !important;
  min-width: 100%;
  transition: max-height 0.5s, min-height 0.5s;
  .content-constraint {
    position: relative;
    display: flex;
    justify-content: center;
    transition: max-height 0.5s, min-height 0.5s;
    min-height: 82px !important;
  }
}
@media only screen and (max-width: $breakpoint-sm) {
  .main-nav.sticking:not(.nav-open) {
    max-height: 65px !important;
    min-height: 65px !important;
  }
}
</style>
